import React from 'react';
import { Blocks } from 'lucide-react';
import styles from './Integrations.module.css';

function Integrations() {
  return (
    <div className="vercel-deploy-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <div className="under-dev-container">
        {/* Decorative background glow */}
        <div style={{
          position: 'absolute',
          top: '-20%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '200px',
          height: '200px',
          background: 'var(--primary)',
          opacity: 0.15,
          filter: 'blur(60px)',
          borderRadius: '50%',
          pointerEvents: 'none'
        }} />

        <div style={{ 
          width: '64px', 
          height: '64px', 
          background: 'linear-gradient(135deg, var(--primary), var(--primary-hover))', 
          borderRadius: '20px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          margin: '0 auto 2rem',
          boxShadow: '0 10px 20px -5px rgba(var(--primary-rgb), 0.4)'
        }}>
          <Blocks size={32} color="white" strokeWidth={2.5} />
        </div>
        
        <h2 className="under-dev-title">
          Integrations
        </h2>
        
        <p className="under-dev-description">
          Connect third-party tools like GitHub, Slack, Datadog, and PagerDuty to supercharge your deployment workflow with zero manual setup.
        </p>

        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1.25rem',
          background: 'rgba(var(--primary-rgb), 0.1)',
          borderRadius: '999px',
          border: '1px solid rgba(var(--primary-rgb), 0.2)'
        }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--primary)', animation: 'pulse 2s infinite' }} />
          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--primary)', letterSpacing: '0.02em', textTransform: 'uppercase' }}>Available Soon</span>
        </div>
      </div>
    </div>
  );
}

export default Integrations;
